<template>
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" loader="bars" />

    <p class="font-bold">
    <h5>Pendaftaran Rawat Jalan Online</h5>
    Pendaftaran Online adalah fitur yang digunakan untuk mendaftar dilayanan rawat jalan.
    </p>

    <p-message severity="warn" :closable="false">Khusus Pasien Yang belum Mempunyai No. RM (Rekam Medis) silahkan <a
            target="_blank" href="https://wa.me/+6281232009725">Klik
            Link ini.</a></p-message>

    <p-message severity="info" :closable="false">Khusus Pasien Yang sudah Memiliki nomor Rekamedis / RM / Nomor
        Pasien</p-message>

    <p-message v-if="error" severity="error">{{error}}</p-message>
    <p-message v-if="success" severity="success">{{success}}</p-message>

    <!------------------------------------------------------------------------------------------>
    <div class="grid align-items-center justify-content-center">
        <!-------------------------------------------------------------------------------------->
        <div class="hidden lg:block col-12  md:col-12 lg:col-3 xl:col-3" v-if="isIklan">
            <p-card class="mb-5 card">
                <template #content>
                    <p class="m-0">

                    </p>
                </template>
            </p-card>
        </div>
        <!-------------------------------------------------------------------------------------->

        <!-------------------------------------------------------------------------------------->
        <!-------------------------------------------------------------------------------------->
        <div class="col-12  md:col-12 lg:col-6 xl:col-6 ">
            <!--===============================================================================-->
            <!-------------------------------AREA 01--------------------------------------------->
            <!--===============================================================================-->
            <!--Syarat-------------------------------------------------------------------------->
            <p-card class="mb-5 card" v-if="posisi == 1">
                <template #title><font-awesome-icon :icon="['fas', 'square-check']" /> <span
                        class="text-base md:text-xl">Syarat Pendaftaran Online</span></template>
                <template #content>
                    <hr>
                    <p class="m-0" v-if="isLodingSyarat">
                    <ol>
                        <li class="mb-4">
                            <p-skeleton height="2rem" class="mb-2" borderRadius="16px" />
                        </li>
                        <li class="mb-4">
                            <p-skeleton height="2rem" class="mb-2" borderRadius="16px" />
                        </li>
                        <li class="mb-4">
                            <p-skeleton height="2rem" class="mb-2" borderRadius="16px" />
                        </li>
                        <li class="mb-4">
                            <p-skeleton height="2rem" class="mb-2" borderRadius="16px" />
                        </li>
                    </ol>
                    </p>
                    <p v-else v-html="syarat_jenis.syarat"></p>
                    <!-------------------------------------------------------------------------->
                    <hr>
                    <div class="flex justify-content-center flex-wrap">
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button v-if="!isLodingSyarat" @click="lanjut" severity="success" rounded outlined>Lanjut
                                <font-awesome-icon :icon="['fas', 'circle-right']" /></p-button>
                        </div>
                    </div>
                    <!-------------------------------------------------------------------------->
                </template>
            </p-card>
            <!--Syarat-------------------------------------------------------------------------->

            <!--Jenis / Penjamin---------------------------------------------------------------->
            <p-card class="mb-5 card" v-if="posisi == 2">
                <template #title><font-awesome-icon :icon="['fas', 'money-bills']" /> <span
                        class="text-base md:text-xl">Pilih Jenis / Status Pendaftaran</span></template>
                <template #content>
                    <span class="text-base font-bold">Silahkan Pilih</span>
                    <hr>
                    <p class="m-0">
                    <div class="grid justify-content-center align-content-center">

                        <!--
                            <div class="col-12 md:col-6 lg:col-4 xl:col-4 " v-for="(item, index) in syarat_jenis.jenis" :key="index" >
                                <p-card class="card pb-0">
                                    <template #title>
                                        <font-awesome-icon v-if="item.type == 'TUNAI'" :icon="['fas', 'money-bill']" />
                                        <font-awesome-icon v-if="item.type == 'BPJS'" :icon="['fas', 'credit-card']" />
                                        <font-awesome-icon v-if="item.type == 'CUSTOM'" :icon="['fas', 'file-invoice']" />
                                        {{item.nama}}
                                    </template>
                                    <template #subtitle>{{item.keterangan}}</template>
                                    <template #content>
                                        <div class="grid p-0">
                                            <div class="col-12 sm:col-9 md:col-12 lg:col-12 xl:col-12">
                                                <p-inline-message v-if="item.keterangan_ke_pasien" severity="warn" class="w-full">{{item.keterangan_ke_pasien}}</p-inline-message>
                                            </div>
                                            <div class="col-12 sm:col-3 md:col-12 lg:col-12 xl:col-12 text-right">
                                                <p-button @click="pilihJenis(item)" severity="success" rounded >LANJUT <font-awesome-icon :icon="['fas', 'circle-arrow-right']" /></p-button>
                                            </div>
                                        </div>
                                    </template>
                                </p-card>
                            </div>
                           -->

                        <div class="col-12 md:col-6 lg:col-4 xl:col-4 justify-content-center align-content-center">
                            <img @click="pilihJenis({id:1, type: 'TUNAI'})" width="100%"
                                :src="require(`@/assets/p-umum.png`)" alt="">
                        </div>

                        <div class="col-12 md:col-6 lg:col-4 xl:col-4 justify-content-center align-content-center">
                            <img @click="$router.push('/mjkn')" width="100%" :src="require(`@/assets/m-jkn.png`)"
                                alt="">
                        </div>




                    </div>
                    </p>
                    <!-------------------------------------------------------------------------->
                    <hr>
                    <div class="flex justify-content-center ">
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="kembali" severity="info" rounded outlined><font-awesome-icon
                                    :icon="['fas', 'circle-left']" /> Kembali</p-button>
                        </div>
                    </div>
                    <!-------------------------------------------------------------------------->
                </template>
            </p-card>
            <!--Jenis / Penjamin---------------------------------------------------------------->
            <!--===============================================================================-->
            <!-------------------------------AREA 01--------------------------------------------->
            <!--===============================================================================-->


            <!--===============================================================================-->
            <!-------------------------------AREA 02--------------------------------------------->
            <!--===============================================================================-->
            <!--Input Data---------------------------------------------------------------------->
            <p-card class="mb-5 card" v-if="posisi == 3">
                <template #title><font-awesome-icon :icon="['fas', 'address-card']" /> <span
                        class="text-base md:text-xl">Input Data Pasien</span></template>
                <template #content>
                    <span class="text-base font-bold">Data Pasien {{jenis.nama}} :</span>
                    <hr>
                    <p class="m-0">
                        <!--RM------------------------------------------------------------------>
                    <div class="flex flex-column gap-2">
                        <label class="font-bold" for="no_rm">Silahkan Masukan Nomor Rekam Medis (RM) Anda :
                            <font-awesome-icon :icon="['fas', 'hand-point-down']" /></label>
                        <p-inputtext v-model="no_rm" type="number" placeholder="klik disini untuk isi nomor RM"
                            autofocus />
                        <span v-if="errors.no_rm" class="text-red-500">{{errors.no_rm}}</span>
                    </div>
                    <!--RM------------------------------------------------------------------>

                    <!--BPJS---------------------------------------------------------------->
                    <div class="flex flex-column gap-2 mt-5" v-if="jenis.type=='BPJS'">
                        <label class="font-bold" for="no_bpjs">Silahkan Masukan Nomor BPJS/KIS/NIK Anda :
                            <font-awesome-icon :icon="['fas', 'hand-point-down']" /></label>
                        <p-inputtext v-model="no_bpjs" type="number"
                            placeholder="klik disini untuk isi nomor BPJS/KIS/NIK" />
                        <span v-if="errors.no_bpjs" class="text-red-500">{{errors.no_bpjs}}</span>
                    </div>
                    <!--BPJS---------------------------------------------------------------->
                    </p>
                    <!-------------------------------------------------------------------------->
                    <hr>
                    <div class="flex justify-content-center flex-wrap">
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="backTwo" severity="info" rounded outlined><font-awesome-icon
                                    :icon="['fas', 'circle-left']" /> Kembali</p-button>
                        </div>
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="toFour" severity="success" rounded outlined>Lanjut <font-awesome-icon
                                    :icon="['fas', 'circle-right']" /></p-button>
                        </div>
                    </div>
                    <!-------------------------------------------------------------------------->
                </template>
            </p-card>
            <!--Input Data---------------------------------------------------------------------->
            <!--===============================================================================-->
            <!-------------------------------AREA 02--------------------------------------------->
            <!--===============================================================================-->


            <!--===============================================================================-->
            <!-------------------------------AREA 03--------------------------------------------->
            <!--===============================================================================-->
            <!--Poli dan Tanggal---------------------------------------------------------------->
            <p-card class="mb-5 card" v-if="posisi == 4">
                <template #title><font-awesome-icon :icon="['fas', 'calendar-check']" /> <span
                        class="text-base md:text-xl">Poli dan Tanggal</span></template>
                <template #content>
                    <!-------------------------------------------------------------------------->
                    <span class="text-base font-bold">Data Pasien {{jenis.type}} :</span>
                    <hr>
                    <p class="m-0">
                    <table class="text-base font-bold">
                        <tr>
                            <td>Nomor RM</td>
                            <td>:</td>
                            <td>{{data_pasien.no_rm}}</td>
                        </tr>
                        <tr>
                            <td>Nama</td>
                            <td>:</td>
                            <td>{{data_pasien.nama}}</td>
                        </tr>
                        <tr v-if="jenis.type == 'BPJS'">
                            <td>Nomor {{no_bpjs.length == 13 ? 'BPJS' : ''}} {{no_bpjs.length == 16 ? 'NIK/KTP' : ''}}
                            </td>
                            <td>:</td>
                            <td>{{no_bpjs}}</td>
                        </tr>
                    </table>
                    </p>
                    <hr>
                    <br>
                    <!-------------------------------------------------------------------------->
                    <!---PILIH POLI------------------------------------------------------------->
                    <!-------------------------------------------------------------------------->
                    <span class="text-base font-bold mt-4">Silahkan Pilih Poli dan Tanggal :</span>
                    <hr>
                    <p class="m-0">
                        <!---------------------------------------------------------------------->
                    <div class="mt-4">
                        <span class="text-base font-bold ">Silahkan Pilih Poli :</span>
                        <!------------------------------------------------------------------>
                        <p-dropdown @change="changePoli" v-model="selectedPoli" filter :options="data_pasien.poli"
                            optionLabel="nama_poli" placeholder="klik disini untuk pilih poli" class="w-full">
                            <!-------------------------------------------------------------->
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex align-items-center">
                                    <div class="font-bold"><p-badge :value="slotProps.value.kode_poli"></p-badge> {{
                                        slotProps.value.nama_poli }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>
                            <!-------------------------------------------------------------->
                            <template #option="slotProps">
                                <div class="flex align-items-center">
                                    <p-chip class="py-0 pl-0 pr-3">
                                        <span
                                            class="bg-primary border-circle w-2rem h-2rem flex align-items-center justify-content-center">{{slotProps.option.kode_poli}}</span>
                                        <span class="ml-2 font-medium">{{ slotProps.option.nama_poli }}</span>
                                    </p-chip>
                                </div>
                            </template>
                            <!-------------------------------------------------------------->
                        </p-dropdown>
                        <!------------------------------------------------------------------>
                        <span v-if="errors.poli" class="text-red-500">{{errors.poli}}</span>
                        <!------------------------------------------------------------------>
                        <p-fieldset v-if="selectedPoli && jenis.type == 'BPJS'" legend="rujukan" :toggleable="true"
                            class="mt-3">
                            <p class="m-0">
                            <table>
                                <tr>
                                    <td>faskes</td>
                                    <td>:</td>
                                    <td>{{selectedPoli.rujukan.nama_faskes}}</td>
                                </tr>
                                <tr>
                                    <td>nomor rujukan</td>
                                    <td>:</td>
                                    <td>{{selectedPoli.rujukan.pos_opname ? "POS" : selectedPoli.rujukan.kode_poli}} :
                                        {{selectedPoli.rujukan.no_rujukan}}</td>
                                </tr>
                                <tr>
                                    <td>tgl dibuat</td>
                                    <td>:</td>
                                    <td>{{selectedPoli.rujukan.tgl_dibuat}}</td>
                                </tr>
                            </table>
                            </p>
                        </p-fieldset>
                        <!------------------------------------------------------------------>
                    </div>
                    <!---------------------------------------------------------------------->


                    <!---------------------------------------------------------------------->
                    <!----PILIH TANGGAL----------------------------------------------------->
                    <!---------------------------------------------------------------------->
                    <div class="mt-6">
                        <span class="text-base font-bold ">Silahkan Pilih Tanggal Pemeriksaan :</span>
                        <!------------------------------------------------------------------>
                        <p-dropdown :disabled="!date_range.length" @change="changeDate" v-model="selectedDate" filter
                            :options="date_range" optionLabel="tgl" placeholder="klik disini untuk pilih Tanggal"
                            class="w-full" optionDisabled="disabled">
                            <!-------------------------------------------------------------->
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex align-items-center">
                                    <div class="font-bold">{{ slotProps.value.hari }} : {{ slotProps.value.tgl }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>
                            <!-------------------------------------------------------------->
                            <template #option="slotProps">
                                <div class="flex flex-column">
                                    <div class="flex ">
                                        <p-chip class="py-0 pl-0 pr-3">
                                            <span
                                                class="border-circle w-2rem h-2rem flex align-items-center justify-content-center"
                                                :class="{'bg-green-500' : slotProps.option.status, 'bg-red-500' : !slotProps.option.status}">
                                                <font-awesome-icon
                                                    :icon="slotProps.option.disabled ? ['fas', 'xmark'] : ['fas', 'arrow-pointer']" />
                                            </span>
                                            <span class="ml-2 font-medium">{{ slotProps.option.hari }} : {{
                                                slotProps.option.tgl }}</span>
                                        </p-chip>
                                    </div>
                                    <div class="flex ">
                                        <p-chip class="py-0 pl-0 pr-3 ml-4" v-if="slotProps.option.disabled">
                                            <span class="text-red-500 p-1 ml-1"> {{ slotProps.option.keterangan
                                                }}</span>
                                        </p-chip>
                                    </div>
                                </div>
                            </template>
                            <!-------------------------------------------------------------->
                        </p-dropdown>
                        <!------------------------------------------------------------------>
                        <span v-if="errors.tanggal" class="text-red-500">{{errors.tanggal}}</span>
                    </div>
                    <!---------------------------------------------------------------------->


                    <!---------------------------------------------------------------------->
                    <!----PILIH DOKTER------------------------------------------------------>
                    <!---------------------------------------------------------------------->
                    <div class="mt-6" v-if="selectedDate?.dokter.length">
                        <span class="text-base font-bold ">Silahkan Pilih Dokter :</span>
                        <p-dropdown :disabled="!selectedDate?.dokter.length" @change="changeDokter"
                            v-model="selectedDokter" filter :options="selectedDate.dokter" optionLabel="nama_dokter"
                            placeholder="klik disini untuk pilih Dokter" class="w-full" optionDisabled="disabled">
                            <!-------------------------------------------------------------->
                            <template #value="slotProps">
                                <div v-if="slotProps.value" class="flex align-items-center">
                                    <div class="font-bold"><font-awesome-icon :icon="['fas', 'user-doctor']" /> {{
                                        slotProps.value.nama_dokter }}</div>
                                </div>
                                <span v-else>
                                    {{ slotProps.placeholder }}
                                </span>
                            </template>
                            <!-------------------------------------------------------------->
                            <template #option="slotProps">
                                <div class="flex flex-column">
                                    <div class="flex ">
                                        <p-chip class="py-0 pl-0 pr-3">
                                            <span
                                                class="border-circle w-2rem h-2rem flex align-items-center justify-content-center"
                                                :class="{'bg-green-500' : slotProps.option.status, 'bg-red-500' : !slotProps.option.status}">
                                                <font-awesome-icon
                                                    :icon="slotProps.option.disabled ? ['fas', 'stethoscope'] : ['fas', 'user-doctor']" />
                                            </span>
                                            <span class="ml-2 font-medium">{{ slotProps.option.nama_dokter }}</span>
                                        </p-chip>
                                    </div>
                                    <div class="flex ">
                                        <p-chip class="py-0 pl-0 pr-3 ml-4" v-if="slotProps.option.disabled">
                                            <span class="text-red-500 p-1 ml-1"> {{ slotProps.option.keterangan
                                                }}</span>
                                        </p-chip>
                                    </div>
                                </div>
                            </template>
                            <!-------------------------------------------------------------->
                        </p-dropdown>
                    </div>
                    <!---------------------------------------------------------------------->

                    <!---------------------------------------------------------------------->
                    <!----SURAT KONTROL----------------------------------------------------->
                    <!---------------------------------------------------------------------->
                    <div class="mt-6" v-if="wajib_kontrol">
                        <span class="text-base font-bold ">Silahkan Masukan Nomor Surat Kontrol anda :</span>
                        <p-inputtext v-model="kontrol" placeholder="klik disini untuk Masukan Nomor Surat Kontrol anda"
                            class="w-full" />
                        <span v-if="errors.kontrol" class="text-red-500">{{errors.kontrol}}</span>
                    </div>
                    <!---------------------------------------------------------------------->

                    <!---------------------------------------------------------------------->
                    <!----NOMER HP/TLP------------------------------------------------------>
                    <!---------------------------------------------------------------------->
                    <div class="mt-6">
                        <span class="text-base font-bold ">Silahkan Masukan Nomor Handphone yang dapat dihubungi
                            :</span>
                        <p-inputtext v-model="no_tlp" placeholder="klik disini untuk memasukan nomot tlp/HP"
                            class="w-full" />
                    </div>
                    <!---------------------------------------------------------------------->
                    </p>
                    <!-------------------------------------------------------------------------->
                    <hr>
                    <div class="flex justify-content-center flex-wrap">
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="backTree" severity="info" rounded outlined><font-awesome-icon
                                    :icon="['fas', 'circle-left']" /> Kembali</p-button>
                        </div>
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="kirim" severity="success" rounded outlined>Lanjut <font-awesome-icon
                                    :icon="['fas', 'circle-right']" /></p-button>
                        </div>
                    </div>
                    <!-------------------------------------------------------------------------->
                </template>
            </p-card>
            <!--Poli dan Tanggal---------------------------------------------------------------->


            <!--===============================================================================-->
            <!-------------------------------AREA 04--------------------------------------------->
            <!--===============================================================================-->

            <!--Antrian Anda-------------------------------------------------------------------->
            <p-card class="mb-5 card" v-if="posisi == 5">
                <template #title><font-awesome-icon :icon="['fas', 'ticket']" /> <span
                        class="text-base md:text-xl">Antrian Anda</span></template>
                <template #content>
                    <p class="m-0" v-if="antrian">
                        <antrian :data="antrian" />
                    </p>
                    <!-------------------------------------------------------------------------->
                    <hr>
                    <div class="flex justify-content-center flex-wrap">
                        <div class="flex align-items-center justify-content-center m-2">
                            <p-button @click="backHome" severity="info" rounded outlined><font-awesome-icon
                                    :icon="['fas', 'home']" /> Menu Awal</p-button>
                        </div>
                    </div>
                    <!-------------------------------------------------------------------------->
                </template>
            </p-card>
            <!--Antrian Anda-------------------------------------------------------------------->


        </div>
        <!-------------------------------------------------------------------------------------->
        <!-------------------------------------------------------------------------------------->


        <!-------------------------------------------------------------------------------------->
        <div class="col-12  md:col-12 lg:col-3 xl:col-3" v-if="isIklan">
            <p-card class="mb-5 card">
                <template #content>

                </template>
            </p-card>
        </div>
        <!-------------------------------------------------------------------------------------->

    </div>
    <!------------------------------------------------------------------------------------------>





    <!------------------------------------------------------------------------------------------>
    <p-confirm-dialog group="headless">
        <template #container="{ message, acceptCallback, rejectCallback }">
            <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
                <div
                    class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                    <i class="pi pi-info text-5xl"></i>
                </div>
                <span class="font-bold text-xl block mb-2 mt-4">{{ message.header }}</span>
                <p class="mb-0 text-lg">{{ message.message }}</p>
                <div class="flex align-items-center gap-2 mt-4">
                    <p-button label="Tutup" icon="pi pi-times" outlined @click="rejectCallback"></p-button>
                </div>
            </div>
        </template>
    </p-confirm-dialog>
    <!------------------------------------------------------------------------------------------>
</template>